import styled from "styled-components"
import PropTypes from "prop-types"

function getColor(type, theme) {
  switch (type) {
    case "success":
      return theme.color.valid
    case "warning":
      return theme.color.warning
    default:
      return theme.color.invalid
  }
}

const InputMessage = styled.span`
  color: ${props => getColor(props.type, props.theme)};
`

InputMessage.propTypes = {
  alert: PropTypes.oneOf(["success", "warning", "error"]),
}

export default InputMessage
